import React from 'react';
import { Helmet } from 'react-helmet';
import { Type } from '@spotify-internal/encore-creator-web';
import { Faq } from '../Faq';

export function LoggedInHelpPage() {
  return (
    <div>
      <Helmet title="FAQ" />
      <Type as="h1" variant={Type.heading1}>
        FAQ
      </Type>
      <Faq />
    </div>
  );
}
